(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fourg-league-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('FourgLeagueNavigation');
  if (!root) return;
  let config;
  try { config = JSON.parse(root.dataset.navigation); } catch { return; }
  const leagues = config.leagues || [];
  if (!leagues.length) return;
  const storageKey = 'fourg.league-navigation.v1';
  const maxAge = 8 * 60 * 60 * 1000;
  const originals = new WeakMap();
  const byHandle = (handle) => leagues.find((league) => league.handle === handle);
  function cleanUrl(raw, league) {
    try {
      const url = new URL(raw, location.origin);
      const base = new URL(league.url, location.origin);
      if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== base.pathname.replace(/\/$/, '')) return league.url;
      const result = new URL(base.href);
      for (const [key, value] of url.searchParams) {
        if (key === 'page' || key === 'sort_by' || key.startsWith('filter.')) result.searchParams.append(key, value);
      }
      return result.pathname + result.search;
    } catch { return league.url; }
  }
  function loadContext() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey));
      if (!saved || !byHandle(saved.handle) || Date.now() - saved.time > maxAge) return null;
      if (saved.account !== 'guest' && String(saved.account) !== String(config.account)) return null;
      return saved;
    } catch { return null; }
  }
  function saveContext(league, url) {
    const context = {handle: league.handle, url: cleanUrl(url, league), account: config.account, time: Date.now()};
    try { sessionStorage.setItem(storageKey, JSON.stringify(context)); } catch {}
    return context;
  }
  function clearContext() {
    try { sessionStorage.removeItem(storageKey); } catch {}
  }
  function chooseContext() {
    const saved = loadContext();
    const current = byHandle(config.collection);
    const requested = byHandle(new URL(location.href).searchParams.get('fourg_catalog'));
    const account = leagues.filter((league) => league.accountMatch);
    let league;
    if (config.pageType === 'collection') {
      if (!current) { clearContext(); return null; }
      return {league: current, ...saveContext(current, location.href)};
    }
    if (config.pageType === 'product') {
      const memberships = config.productCollections || [];
      const valid = (item) => item && memberships.includes(item.handle);
      league = valid(requested) ? requested : valid(current) ? current : null;
      if (!league && account.length === 1 && valid(account[0])) league = account[0];
      if (!league && saved && valid(byHandle(saved.handle))) league = byHandle(saved.handle);
      if (!league) { clearContext(); return null; }
    } else {
      if (account.length === 1) league = account[0];
      else if (saved) league = byHandle(saved.handle);
      if (!league) return null;
    }
    const url = saved && saved.handle === league.handle ? saved.url : league.url;
    return {league, ...saveContext(league, url)};
  }
  let context = chooseContext();
  function updateLink(link, label) {
    if (!originals.has(link)) originals.set(link, {href: link.getAttribute('href'), text: link.textContent});
    if (link.getAttribute('href') !== context.url) link.setAttribute('href', context.url);
    if (link.textContent !== label) link.textContent = label;
  }
  function apply() {
    if (!context) {
      document.querySelectorAll('[data-fourg-continue], [data-fourg-product-link]').forEach((link) => {
        const original = originals.get(link);
        if (!original) return;
        if (link.getAttribute('href') !== original.href) link.setAttribute('href', original.href);
        if (link.textContent !== original.text) link.textContent = original.text;
      });
      document.querySelectorAll('[data-fourg-product-return], [data-fourg-drawer-return]').forEach((element) => { element.hidden = true; });
      document.querySelectorAll('[data-fourg-original-breadcrumb]').forEach((element) => { element.hidden = false; });
      return;
    }
    document.querySelectorAll('[data-fourg-continue]').forEach((link) => updateLink(link, context.league.continueLabel));
    document.querySelectorAll('[data-fourg-drawer-return]').forEach((element) => { element.hidden = false; });
    if (config.pageType === 'product') {
      document.querySelectorAll('[data-fourg-product-link]').forEach((link) => updateLink(link, context.league.backLabel));
      document.querySelectorAll('[data-fourg-product-return]').forEach((element) => { element.hidden = false; });
      document.querySelectorAll('[data-fourg-original-breadcrumb]').forEach((element) => { element.hidden = true; });
    }
    if (config.pageType === 'collection') {
      document.querySelectorAll('#MainContent a[href]').forEach((link) => {
        const url = new URL(link.href, location.origin);
        if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
        if (url.searchParams.get('fourg_catalog') === context.handle) return;
        url.searchParams.set('fourg_catalog', context.handle);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      });
    }
  }
  apply();
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; apply(); });
  });
  observer.observe(document.body, {childList: true, subtree: true});
  document.addEventListener('click', (event) => {
    if (config.pageType !== 'collection') return;
    const link = event.target.closest('a[href]');
    const current = byHandle(config.collection);
    if (current && link) context = {league: current, ...saveContext(current, location.href)};
  }, true);
  window.addEventListener('pageshow', () => { context = chooseContext(); apply(); });
})();
  } catch(e) { console.error(e); }
})();

})();
